import React from 'react'
import { Link } from 'react-router-dom'

function TopbarHome() {
    return (
        <>
            <header className="navbar-light fixed-top header-static bg-mode">
                {/* Logo Nav START */}
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        {/* Logo START */}
                        <a className="navbar-brand" href="/">
                            <img className="light-mode-item navbar-brand-item" src="../../assets/images/bg/05.png" alt="logo" />
                        </a>
                        {/* Logo END */}
                        {/* Responsive navbar toggler */}
                        <button className="navbar-toggler ms-auto icon-md btn btn-light p-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-animation">
                                <span />
                                <span />
                                <span />
                            </span>
                        </button>
                        {/* Main navbar START */}
                        <div className="collapse navbar-collapse" id="navbarCollapse">
                            {/* Nav Search START */}

                            {/* Nav Search END */}
                            <ul className="navbar-nav navbar-nav-scroll ms-auto">

                                <li className="nav-item">
                                    <a className="nav-link" href="/">Home</a>
                                </li>
                                {/* <li className="nav-item">
                                    <a className="nav-link" href="/">About</a>
                                </li> */}
                                {/* <li className="nav-item">
                                    <a className="nav-link" href="/">Contact</a>
                                </li> */}

                            </ul>
                        </div>
                        {/* Main navbar END */}
                        {/* Nav right START */}
                        <ul className="nav flex-nowrap align-items-center ms-sm-3 list-unstyled">

                            <li className="nav-item ms-2">
                                <Link to="/signin"><button type="submit" class="btn btn-primary mb-0">Login</button>
                                </Link>
                                <Link to="/signup"><button type="submit" class="btn btn-primary mb-0 ms-2">register</button>
                                </Link>
                            </li>
                            {/* Profile START */}
                        </ul>
                        {/* Nav right END */}
                    </div>
                </nav>
                {/* Logo Nav END */}
            </header>







        </>
    )
}

export default TopbarHome